



































import Component from "vue-class-component";
import Vue from "vue";
import {Project} from "../model/interface/project.interface";
import {Collection} from "../model/interface/collection.interface";
import {Prop, Watch} from "vue-property-decorator";
import ProjectHandleComponent from "./project-handle.vue";
import {Observer, Subject} from "../model/interface/subject-observer.interface";
import {ProjectService} from "../services/project.service";
import {MessageBus} from "../services/messageBus";
import {AlertType} from "../model/enum/alert.enum";
import {Author} from "../model/interface/author";
import {WhitelistService} from "../services/whitelist.service";

@Component
export default class AuthorAddMultiComponent extends Vue {
  @Prop(Number) activateDialog!: number;
  @Prop(Number) projectId!: number;
  @Prop(Array) whitelist!: Author[];

  private proposedWhitelist: Author[] = [];
  private file: File | undefined | null = null;
  private loading: boolean = false;
  private showDialog: boolean = false;
  private validate: boolean = false;

  get noWhitelistPresent() {
    return this.proposedWhitelist.length === 0;
  }
  get getDisabled() {
    return {
      'wimpub_button_disabled': this.noWhitelistPresent
    };
  }

  private cancel() {
    this.showDialog = false;
    this.proposedWhitelist = [];
  }

  private async submitAuthors() {
    try {
      //Call to API
      const added: Author[] | false = await WhitelistService.addAuthorMultiToWhitelist(this.projectId, this.proposedWhitelist);
      if (added) {
        MessageBus.$emit(AlertType[AlertType.success], `Authors successfully added to Whitelist!`);
        this.whitelist.push(...added);
      }
    } catch (e) {
      MessageBus.$emit(AlertType[AlertType.error], 'Error during author addition! ' + e);
    } finally {
      this.showDialog = false;
      this.proposedWhitelist = [];
    }
  }

  @Watch("activateDialog")
  onDialogChange(activateDialog: number) {
    this.showDialog = true;
  }


  private onFileChange(event: any) {
    this.file = event.target.files[0];

    if (!this.file) {
      MessageBus.$emit(AlertType[AlertType.error], "No File!");
      return;
    }
    const fileReader: FileReader = new FileReader();

    fileReader.onloadstart = () => {
      this.loading = true;
    };
    fileReader.onloadend = async () => {
      try {
        const jobJson = <string>fileReader.result;
        const whitelist: Author[] = JSON.parse(jobJson);
        this.proposedWhitelist = whitelist;
        this.loading = false;
      } catch (e) {
        MessageBus.$emit(AlertType[AlertType.error], "Error reading Job! " + e);
        this.resetInput();
      }
    };

    fileReader.readAsText(this.file);
  };

  private resetInput() {
    this.file = undefined;

    const input: any = this.$refs.mdFile;
    input.type = 'text';
    input.type = 'file';
  };

}
